import React, { useState, useEffect } from 'react'
import TitleList from './TitleList';
import Tabs from './Tab';


function TitleCustomizations(props) {
  const [titles, setTitles] = useState([]);
  const [currentTab, setCurrentTab] = useState(0);
  useEffect(() => {
    if (props.titles) {
      setTitleData(props.titles);
    }
  }, [props.titles]);

  const setTitleData = (data) => {
    let titlesData = [];
    data.forEach((item, index) => {
      titlesData.push({
        title: item.title,
        sectionTitle: item.sectionTitle,
        sectionSubTitle: item.sectionSubTitle,
        navbarTitle: item.navbarTitle,
        show: index == 0,
        isValid: false,
        ref: null
      })
    });
    setTitles(titlesData);
  }

  const getData = () => {
    let titlesData = [];

    titles.forEach(title => {
      let data = title.ref?.getData() ?? null;
      if (data)
        titlesData.push({
          title: data.title,
          sectionTitle: data.sectionTitle,
          sectionSubTitle: data.sectionSubTitle,
          navbarTitle: data.navbarTitle
        });
    });
    return titlesData;
  }
  const handleTabClick = (index) => {
    setCurrentTab(index);
  };

  const saveHandler = (e) => {
    e.preventDefault();
    props.onSave(getData());
  }

  return (
    <div className="modal fade show" aria-modal="true" role="dialog" style={{ display: "block" }}>
      <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Customize Theme</h5>
            <button type="button" className="btn-close" onClick={props.onClose} aria-label="Close"></button>
          </div>
          <div className="modal-body">
            <div className="content d-block visible">
              <form>
                <div className="row g-3">

                  <div className="mt-3">
                    <Tabs tabs={titles} currentTab={currentTab} onTabClick={handleTabClick} />
                    <div className="tab-content mt-2">
                      {titles.map((title, index) => (
                        <div
                          key={index}
                          className={`tab-pane fade ${currentTab === index ? 'show active' : ''}`}
                        >
                          <TitleList data={title} index={index} key={index} ref={el => title.ref = el} />
                        </div>
                      ))}

                    </div>
                    <div className='d-flex justify-content-end'>
                      <button
                        className="btn btn-primary btn-next mt-3"
                        onClick={saveHandler}>
                        Save & Preview
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
};


export default TitleCustomizations;
